import React from 'react';
import { ShiftProviderUser } from 'models';
import { Colors } from 'library';
import { Avatar, Link, Row } from 'library/ui';

export default function ProviderDisplay({
    provider,
    containerStyles,
}: {
    provider: ShiftProviderUser;
    containerStyles?: React.CSSProperties;
}) {
    return (
        <div style={containerStyles}>
            <Row gap="sm" align="center">
                <Avatar
                    imageUrl={provider.profile_picture?.image}
                    initials={provider.first_name[0] + provider.last_name[0]}
                    size={25}
                    color={Colors.darkNavy}
                />
                <Link to={`/provider/${provider.id}`} weight="semibold">
                    {provider.first_name} {provider.last_name}
                </Link>
            </Row>
        </div>
    );
}
